<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title1">The Big Midget Murders</h1>
<p class="title2">A John J. Malone Mystery</p>
<p class="auth">Craig Rice</p>
<div class="img_container4">
<img alt="Image" src="images/logo3.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?a66f4a70